import React, { useCallback, useState } from 'react'
import cx from 'classnames'
import { Button, ControlledTooltip, Label } from '../../../../../../views/components'
import styles from './AccountDetails.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { uiEvents } from 'modules/ui'
import PortfolioStatusLabel from 'modules/portfolios/components/PortfolioStatusLabel'
import WithdrawModal from 'modules/contacts/components/WithdrawModal/WithdrawModal'
import { userApiSelectors } from 'modules/api/user'
interface AccountDetailsProps {
  paymentReference: string
  accountId: string
  isConsolidatedBalance: boolean
  accountTag: string
  accountAddress: string
  status: 'good' | 'bad'
  partyId: string
  partyHasBankDetails: boolean
  partyAccountBalance: number
  partyAccountAsset: any
  accountMeta?: string
  portfolioId?: string
}

const AccountDetails = ({
  paymentReference,
  accountId,
  accountTag,
  accountAddress,
  status,
  partyId,
  partyHasBankDetails,
  partyAccountBalance,
  partyAccountAsset,
  isConsolidatedBalance,
  accountMeta,
  portfolioId,
}: AccountDetailsProps) => {
  const classes = cx([styles.root, [styles[`status-${status}`]]])
  const dispatch = useDispatch()

  const [isOpen, setIsOpen] = useState(false)

  const openPortfolio = useCallback(() => {
    dispatch(uiEvents.redirect(`/leases/${portfolioId}`))
  }, [portfolioId])

  const toolTipBody = !partyHasBankDetails ? 'No bank details' : partyAccountBalance === 0 ? 'No funds to withdraw' : ''

  const userRole = useSelector(state => userApiSelectors.getUserRole(state))

  return (
    <>
      <div className={classes}>
        <header>
          <strong>{accountTag} Wallet</strong>
          <span>{paymentReference}</span>
        </header>
        <section className={styles['account-meta']}>
          <div className={styles['account-actions']}>
            {portfolioId ? (
              <PortfolioStatusLabel
                labelProps={{ as: Button, onClick: openPortfolio }}
                portfolioId={portfolioId}
                useSummary
                statusPrefix="View"
                statusSuffix="lease"
              />
            ) : isConsolidatedBalance ? (
              <Label circular className={styles['consolidated-label']}>
                Consolidated
              </Label>
            ) : null}
            {partyAccountBalance !== 0 && partyHasBankDetails && userRole === 'Owner' ? (
              <Button pill tertiary size="sm" onClick={() => setIsOpen(true)}>
                Withdraw
              </Button>
            ) : userRole === 'Owner' ? (
              <ControlledTooltip body={toolTipBody} place="above">
                <Button pill tertiary size="sm" onClick={() => {}}>
                  Withdraw
                </Button>
              </ControlledTooltip>
            ) : null}
          </div>
        </section>
        <section className={styles.address}>
          <>
            {accountAddress} <br />
            {accountMeta && <small>{accountMeta}</small>}
          </>
        </section>
      </div>
      <WithdrawModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        partyAccountId={accountId}
        partyAccountBalance={partyAccountBalance}
        partyAccountAssetName={partyAccountAsset?.name}
        partyId={partyId}
        partyTag={accountTag}
        walletRef={paymentReference}
        isConsolidatedBalance={isConsolidatedBalance}
      />
    </>
  )
}

export default AccountDetails
